import { useState } from "react";
import "./auth.scss";
import firebase from "firebase/app";
import { useUser } from "../contexts/user";
import { toast } from "react-hot-toast";


const RandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
let avatars = [
  "https://hackernoon.imgix.net/avatars/robot-a1.png",
  "https://hackernoon.imgix.net/avatars/robot-a2.png",
  "https://hackernoon.imgix.net/avatars/robot-a3.png",
  "https://hackernoon.imgix.net/avatars/robot-a4.png",
  "https://hackernoon.imgix.net/avatars/robot-a5.png",
  "https://hackernoon.imgix.net/avatars/robot-a6.png",
  "https://hackernoon.imgix.net/avatars/robot-b1.png",
  "https://hackernoon.imgix.net/avatars/robot-b2.png",
  "https://hackernoon.imgix.net/avatars/robot-b3.png",
  "https://hackernoon.imgix.net/avatars/robot-b4.png",
  "https://hackernoon.imgix.net/avatars/robot-b5.png",
  "https://hackernoon.imgix.net/avatars/robot-b6.png",
];

const AuthForm = () => {
  const { setUserData } = useUser();
  const [isSignup, setIsSignup] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [loading, setLoading] = useState(false);
  const [firebaseError, setFirebaseError] = useState(null);
  const [emailError, setEmailError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLoginWithEmailAndPass = async () => {
    const previousUser = firebase.auth().currentUser;
    firebase
      .auth()
      .signInWithEmailAndPassword(form?.email, form?.password)
      .then(result => {
        if (previousUser && previousUser.isAnonymous) {
          try {
            previousUser.linkWithCredential(result.credential).catch(err => {
            });
          } catch (err) {
            console.error(err)
          }
        }
        // console.log("im heree", result.user)
        handleSuccessfulAuth(result.user);
      })
      .catch(error => {
        handleError(error);
      });
  }

  const handleSigninWithEmailAndPass = async () => {
    if (!acceptedTerms) {
      setFirebaseError("You need to accept the terms and policies");
      return;
    }
    let signupEmail = form?.email;
    let password = form?.password;
    try {
      const createUser = await firebase.auth().createUserWithEmailAndPassword(signupEmail, password);

      await setUserData(createUser?.user);
      toast.success("Account created successfully!");

    } catch (e) {
      console.log("something went wrong!", e);
      handleError(e);
    }
  }

  const handleError = (err) => {
    // console.log("err:", err)
    const str = typeof err === 'string' ? err : err?.message || String(err);
    let parsed = null;
    try {
      const start = str.indexOf('{');
      const end = str.lastIndexOf('}');
      if (start !== -1 && end > start) {
        parsed = JSON.parse(str.slice(start, end + 1));
      }
    } catch (err) {
      console.error("Error parsing error string:", err);
    }

    const code = parsed?.error?.code ?? parsed?.code;
    let msg

    if (code === 400) {
      msg = "Invalid email or password. Please try again.";
    } else if (code === 404) {
      msg = "User not found. Please check your email or sign up.";
    } else if (code === 401) {
      msg = "Unauthorized access. Please log in.";
    } else if (code === 429) {
      msg = "Too many requests. Please try again later.";
    } else if (code === 500) {
      msg = "Internal server error. Please try again later.";
    } else {
      msg = str || "An unknown error occurred. Please try again.";
    }

    setFirebaseError(msg);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form?.email) {
      setEmailError("Please enter an email address");
      return;
    }
    if (!form?.password) {
      setEmailError("Please enter a password");
      return;
    }
    setLoading(true);
    try {
      if (isSignup) {
        await handleSigninWithEmailAndPass();
      } else {
        await handleLoginWithEmailAndPass();
      }

    } catch (e) {
      console.log("something went wrong!", e);
      handleError(e);
    }

    // setTimeout(() => setLoading(false), 3000)
    setLoading(false);
  }

  const handleSuccessfulAuth = user => {
    setUserData(user);
  };

  const loginWithSocial = async (provider) => {
    if (isSignup && !acceptedTerms) {
      setFirebaseError("You need to accept the terms and policies");
      return;
    }
    setLoading(true);
    try {
      const signInPromise = await firebase.auth().signInWithPopup(provider);
      await setUserData(signInPromise?.user);
    } catch (err) {
      handleError(err);
    }
    setLoading(false);
  };

  return (
    <div className="auth-form">
      <h2>{isSignup ? "Sign Up" : "Log In with HackerNoon"}</h2>

      <form onSubmit={handleSubmit} className="auth-form__form">
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={form?.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form?.password}
          onChange={handleChange}
          required
        />
        {isSignup && (
          <div className="auth-form__terms-checkbox">
            <input
              type="checkbox"
              id="acceptedTerms"
              checked={acceptedTerms}
              onChange={() => {
                setAcceptedTerms(!acceptedTerms);
                if (firebaseError === "You need to accept the terms and policies") {
                  setFirebaseError(null);
                }
              }}
            />
            <label htmlFor="acceptedTerms">
              I accept the{" "}
              <a style={{ color: "var(--hn-green)" }} target="_blank" href="https://hackernoon.com/terms" rel="noopener noreferrer">
                terms
              </a>{" "}
              and{" "}
              <a style={{ color: "var(--hn-green)" }} target="_blank" href="https://hackernoon.com/privacy" rel="noopener noreferrer">
                policies
              </a>
            </label>
          </div>
        )}
        <button type="submit">
          {isSignup ? "Sign Up" : "Log In"}
        </button>
      </form>

      {loading ? (
        <div>
          <br />
          <img className="loading-image" src="/loading.gif" alt="Loading..." width={40} height={40} />
        </div>
      ) : (
        <>
          <p className="auth-form__toggle">
            {isSignup ? "Already have an account?" : "Don't have an account?"}{" "}
            <span onClick={() => {
              setIsSignup(!isSignup);
              setFirebaseError(null);
              setEmailError("");
              setAcceptedTerms(false);
            }}>
              {isSignup ? "Log in" : "Sign up"}
            </span>
          </p>

          <div className="auth-form__divider">or</div>

          <div className="auth-form__socials">
            <button onClick={() => loginWithSocial(new firebase.auth.GoogleAuthProvider())}>
              <i className="hn hn-google text-3xl"></i>
            </button>
            <button onClick={() => loginWithSocial(new firebase.auth.GithubAuthProvider())}>
              <i className="hn hn-github text-3xl"></i>
            </button>
            <button onClick={() => loginWithSocial(new firebase.auth.TwitterAuthProvider())}>
              <i className="hn hn-x text-3xl"></i>
            </button>
          </div>

        </>
      )}
      {firebaseError && <p style={{ color: "red" }}>{firebaseError}</p>}

    </div>
  );

}


export default AuthForm;
